//中文包
module.exports = {
  //头部导航
  // title: {
  //   	index:'首页',
  //   	about:'关于我们',
  // 	news:"最新资讯",
  // 	industrial:"产业活动",
  // 	service:'服务配套',
  // 	policy:'产业服务',
  // 	city:'办公产品',
  // 	ar:'AR全景',
  // advertise:"微城聘"
  // },
  title: {
    index: '首页',
    introduce: '园区介绍',
    policy: '产业政策与服务',
    office: "办公与配套",
    trends: "园区动态",
    service: '办公与配套',	//服务配套
    join: '加入我们',
    ar: 'AR全景'
    // advertise:"微城聘"
  },
  //底部
  footer: {
    link: '友情链接',
    ssc: '云海链',
    sscAll: '云海链控股股份有限公司',
    microCity: 'iSchool海南微城未来学校',
    blueDream: '蓝梦物业',
    ryb: '海南红黄蓝国际幼儿园',
    blueHotel: '蓝海钧华大饭店',
    follow: '关注我们',
    weChat: '微信公众号',
    esWeChat: '企服助手',
    code: '其他二维码',
    contact: '联系我们',
    tel: '电话',
    fax: '传真',
    email: '邮箱',
    post: '邮编',
    addr: '地址',
    addrAll: '海南老城高新技术示范区海南生态软件园沃克公园8848',
    copy: 'Copyright © 2026海南生态软件园集团有限公司版权所有',
    record: '琼ICP备09003112号-1 ',
    recordpolicy: '琼公网安备46902302000149号',
    tech: '技术支持',
  },
  //关于我们
  about: {
    intro: '园区简介',
    care: '领导关怀',
    view: '园区实景',
    join: '加入我们',
    position: '您的位置',
    careOther: '其他领导',
    more: '加载更多',
  },
  //领导关怀
  leader: {
    guojia: '国家领导',
    buwei: '部委领导',
    shengji: '省级领导',
    jituan: '集团领导',
  },
  //加入我们
  join: {
    style: '企业风采',
    park: '园区公司招聘',
    enterPark: '入园企业招聘',
    job: '在招职位',
    look: '查看职位',
  },
  //联系我们
  contact: {
    rsc: '海南生态软件园集团有限公司',
    sina: '官方新浪微博',
    service: '客服服务',
    cooper: '商务合作/广告',
    media: '媒体采访',
    industry: '产业招商',
    internation: '国际事业部',
    name: '联系人',
  },
  //最新资讯
  news: {
    text: '图文资讯',
    video: '视频资讯',
    rsc: '海南生态软件园',
    detail: '资讯详情',
    recommend: '推荐资讯',
    share: '分享资讯',
    weChat: '微信',
    blog: '微博',
    scan: '用微信扫描二维码',
  },
  //服务配套
  service: {
    enter: '进入',
  },
  //政策政务
  policy: {
    business: '企业服务',
    download: '点击下载微城生活服务手册',
    policy: '政策赋能',
  },
}
